import { ActionIcon, Avatar, Badge, Box, Button, Card, Center, Divider, Flex, Grid, Group, Image, Loader, LoadingOverlay, Menu, Modal, Paper, ScrollArea, SimpleGrid, Stack, Text, Textarea, Tooltip } from "@mantine/core"
import { IconCopy, IconDotsVertical, IconExclamationCircle, IconExclamationCircleFilled, IconMoodSmile, IconPaperclip, IconSend2, IconTrash } from "@tabler/icons-react"
import dayjs from "dayjs"
import { useEffect, useRef, useState } from "react"
import { getMessageList, getChatDetail, sendMessage, closeChat, joinChat, sendMessageImage, sendMessageDocument, deleteChat } from "../../../services/chat"
import { useSelector } from "react-redux"
import { notificationError } from "../../ui/Notifications"
import { useViewportSize } from '@mantine/hooks'
import SearchMascot from '../../../assets/img/mascot/18.png'
import AiShaImage from '../../../assets/img/avatar/icon-chat-message-aisha.png'
import imageUserNetral from '../../../assets/img/avatar/netral-avatar.png'
import imageUserMale from '../../../assets/img/avatar/male-avatar.png'
import imageUserFemale from '../../../assets/img/avatar/female-avatar.png'
import { modals } from "@mantine/modals"
import NoImage from '../../../assets/img/images/no-images.png'
import { Dropzone } from "@mantine/dropzone"
import EmojiPicker from "emoji-picker-react"
import { modalDeleteData } from "../../ui/Prompt/modalDeleteData"

function getUserImage(gender) {
  return gender === 'male'
    ? imageUserMale
    : gender === 'female'
      ? imageUserFemale
      : imageUserNetral
}

const today = dayjs()

const defaultMessageStructure =  {
  id: null,
  chatId: 0,
  message: '',
  messageType: null,
  updatedAt: today,
  createdAt: today,
  flag: today,
  user: {
    id: null,
    name: '',
    isAdmin: false,
    isMe: false,
    userProfile: '',
  },
  isLoading: false,
  isFail: false,
}

const DetailChat = ({ dataChat, incomingMessage, reloadList, clearSelectedChat }) => {
  const { height } = useViewportSize()

  const auth = useSelector(state => state.auth.authorization)
  const { data: dataUserLogin } = useSelector(state => state.user_login)
  const { user: userAuth } = auth

  const [dataChatDetail, setDataChatDetail] = useState(null)
  const [dataMessageList, setDataMessageList] = useState(null)

  const [dataAssignees, setDataAssignees] = useState([])
  const [modalAssignees, setModalAssignees] = useState(false)
  const [loadingMessageList, setLoadingMessageList] = useState(false)
  const [loadingCloseChat, setLoadingCloseChat] = useState(false)
  const [loadingJoinChat, setLoadingJoinChat] = useState(false)

  const [textMessage, setTextMessage] = useState('')
  const [showPicker, setShowPicker] = useState(false);
  const openRefImage = useRef(null);
  const openRefDocument = useRef(null);

  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  const openModalAssignees = (detailChat) => {
    const { assignees } = detailChat
    if (assignees.length !== 0) {
      setDataAssignees(assignees)
      setModalAssignees(true)
    }
  }

  // --- GET DETAIL CHAT AND MESSAGES ---
  const getDetailChat = async (id) => {
    try {
      const response = await getChatDetail(id)
      const { data } = response
      const { attributes } = data

      const participantsList = attributes.participants.map(e => e.attributes)
      const remap = {
        id: attributes.id,
        participants: participantsList.map(e => e.user_id),
        assignees: participantsList.filter(e => e.is_admin),
        status: attributes.status[0],
      }

      setDataChatDetail((oldVal) => ({...oldVal, ...remap}))
    } catch (error) {
      console.log(error)
    }
  }

  const getDetailMessages = async (id) => {
    try {
      setLoadingMessageList(true)
      const params = {
        'page[limit]': 10000
      }
      const response = await getMessageList(id, params)
      const { data, included } = response
      const { user } = included

      const remap = data.reduce((arr, e) => {
        const { attributes } = e

        // helper
        const handleGetUser = (attributes, dataUserIncluded) => {
          const { ai_enabled, user_id } = attributes
          const user = dataUserIncluded[user_id]?.attributes || null
          const gender = user?.gender?.value || null
          const defaultImageProfile = getUserImage(gender)

          if (!user_id && ai_enabled) {
              return {
                id: null,
                name: 'AIsha',
                isAdmin: true,
                isMe: false,
                userProfile: AiShaImage,
              }
          }

          return {
            id: user ? user.id : null,
            name: user ? user.name : 'Deleted User',
            isAdmin: user ? user.is_admin : null,
            isMe: userAuth.id === user_id,
            userProfile: user?.photo_profile || defaultImageProfile
          }
        }

        const data = {
          ...defaultMessageStructure,
          id: attributes.id,
          chatId: attributes.chat_id,
          message: attributes.message === '/cs' || attributes.message === 'chat /cs'
            ? 'Chat Customer Service'
            : attributes.message,
          messageType: attributes.message_type,
          updatedAt: attributes.updated_at,
          createdAt: attributes.created_at,
          flag: dayjs(attributes.created_at).format('DD MMMM YYYY'),
          user: handleGetUser(attributes, user),
        }

        const _dateMessage = {
          ...defaultMessageStructure,
          message: dayjs(attributes.created_at).format('DD MMMM YYYY'),
          messageType: 'info',
          flag: dayjs(attributes.created_at).format('DD MMMM YYYY'),
        }

        if(arr.length !== 0) {
          if(arr[arr.length - 1].flag === data.flag) {
            arr.push(data) 
          } else {
            arr.push({ ..._dateMessage })
            arr.push(data) 
          }
        } else {
          arr.push({ ..._dateMessage })
          arr.push(data) 
        }
        return arr
      }, [])

      setDataMessageList(remap)
    } catch (error) {
      notificationError('Can not get message list', error?.message || 'Internal Server Error')
    } finally {
      setLoadingMessageList(false)
    }
  }

  const reloadAll = () => {
    getDetailMessages(dataChatDetail.id)
    getDetailChat(dataChatDetail.id)
    reloadList()
  }

  // --- SEND MESSAGE ---
  const _remapMessageListBeforeSended = (type, message) => {
    return [
      ...dataMessageList,
      {
        ...defaultMessageStructure,
        chatId: dataChatDetail.id,
        message: message,
        messageType: type,
        isLoading: true,
        user: {
          id: userAuth.id,
          name: userAuth.name,
          isAdmin: true,
          isMe: true,
          userProfile: dataUserLogin?.attributes?.photo_profile || getUserImage(dataUserLogin?.attributes?.gender?.value)
        },
      }
    ]
  }

  const _handleSendMessageSuccess = (listMessages, data) => {
    const remap = listMessages.map(msg => {
      if (msg.isLoading) {
        return {
          ...msg,
          id: data.id,
          message: data.message,
          isLoading: false,
        }
      }
      return { ...msg }
    })
    setDataMessageList([...remap])
  }

  const _handleSendMessageFailed = (listMessages) => {
    const remap = listMessages.map(msg => {
      // find the message which is still loading(proccess to send)
      if (msg.isLoading) {
        return {
          ...msg,
          isLoading: false,
          isFail: true,
        }
      }
      return { ...msg }
    })
    setDataMessageList([...remap])
  }

  const handleSendMessage = async () => {
    const tempRemap = _remapMessageListBeforeSended(null, textMessage)
    setDataMessageList([...tempRemap])

    try {
      const payload = {
        chat_id: dataChatDetail.id,
        message: `${textMessage}`
      }
      setTextMessage('')
      const response = await sendMessage(payload)
      const { success, data } = response 
      if(success) {
        if (dataChatDetail?.status?.id === 86 /** status open */) { 
          getDetailChat(dataChatDetail.id)
          reloadList()
        }

        _handleSendMessageSuccess(tempRemap, data)
      }
    } catch (error) {
      _handleSendMessageFailed(tempRemap)
      notificationError('Can not send message to this chat', error?.response?.data?.message || 'Internal Server Error')
    }
  }

  const handleKeyDown = (e) => {
    // Check if Enter is pressed (without Shift)
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Prevent newline
      if (textMessage.trim() !== '') {
        handleSendMessage()
      }
    }
  };

  // --- ATTACHMENT IMAGE AND DOCUMENT ---
  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);

      reader.readAsDataURL(file);
    });
  }

  const handleSendImage = async (file) => {
    const tempRemap = _remapMessageListBeforeSended('image', URL.createObjectURL(file[0]))
    setDataMessageList([...tempRemap])

    try {
      const payload = {
        image_encoded: await fileToBase64(file[0]),
      }

      const response = await sendMessageImage(dataChatDetail.id, payload)
      const { success } = response 
      if(success) {
        if (dataChatDetail?.status?.id === 86 /** status open */) { 
          getDetailChat(dataChatDetail.id)
          reloadList()
        }
        getDetailMessages(dataChatDetail.id)
        setTextMessage('')
      }
    } catch (error) {
      _handleSendMessageFailed(tempRemap)
      notificationError('Can not send message to this chat', error?.response?.data?.message || 'Internal Server Error')
    }
  }

  const handleSendDocument = async (file) => {
    const tempRemap = _remapMessageListBeforeSended('document', 'Dummy-URL-for-Document-it-will-blur-on-html.pdf')
    setDataMessageList([...tempRemap])

    try {
      const payload = {
        document_encoded: await fileToBase64(file[0]),
      }

      const response = await sendMessageDocument(dataChatDetail.id, payload)
      const { success } = response 
      if(success) {
        if (dataChatDetail?.status?.id === 86 /** status open */) {
          getDetailChat(dataChatDetail.id)
          reloadList()
        }
        getDetailMessages(dataChatDetail.id)
        setTextMessage('')
      }
    } catch (error) {
      _handleSendMessageFailed(tempRemap)
      notificationError('Can not send message to this chat', error?.response?.data?.message || 'Internal Server Error')
    }
  }

  const handleErrorFile = (file) => {
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      notificationError('Attachment Error', `${errorMessage}`)
    }
  }

  // --- EMOJI PICKER ---
  const handleEmojiClick = (emojiObject) => {
    setTextMessage((prev) => prev + emojiObject.emoji);
    setShowPicker(false); // close after selecting
  }

  // --- CLOSE CHAT ---
  const handleCloseChat = async () => {
    setLoadingCloseChat(true)
    try {
      const response = await closeChat(dataChatDetail.id)
      const { success } = response 
      if(success) {
        // refresh
        reloadAll()
      }
    } catch (error) {
      notificationError('Can not close this chat', error?.response?.data?.message || 'Internal Server Error')
    } finally {
      setLoadingCloseChat(false)
      modals.closeAll()
    }
  }

  const onCloseChatConfirmation = (name) => {
    return modals.openConfirmModal({
      centered: 'true',
      closeOnConfirm: false,
      withCloseButton: false,
      size: 'lg',
      children: (
        <Box>
          <Box ta='center'>
            <Image src={SearchMascot} fit='contain' h='180' my={20} />
            <Text fw={500} mb={4}>Are you sure you want to close the Chat? </Text>
            <Text fw='bold' mb={14}>"{name}"</Text>
            <Text fz='sm' c='gray.6' mb={20}>Closing chat mean that the User's issue has been resolved. This action cannot be undone</Text>
          </Box>
        </Box>
      ),
      labels: { confirm: 'Close Now', cancel: "Cancel" },
      confirmProps: { color: 'red' },
      onConfirm: () => handleCloseChat(),
    })
  }

  // --- JOINT CHAT ---
  const handleJointChat = async () => {
    setLoadingJoinChat(true)
    try {
      const payload = {
        chat_id : dataChatDetail.id
    }
      const response = await joinChat(payload)
      const { success } = response

      if(success) {
        // refresh
        reloadAll()
      }
    } catch (error) {
      notificationError('Can not join to this chat', error?.response?.data?.message || 'Internal Server Error')
    } finally {
      setLoadingJoinChat(false)
    }
  }

  // --- INCOMING MESSAGE ---
  const handleIncomingMessage = (incomingMessage) => {
    if (+incomingMessage?.chat_id !== +dataChat.id) {
      return
    }

    const { ai_enabled, user } = incomingMessage
    if (user) {
      if (+user.id === +userAuth.id) {
        return
      }
    }

    const isAiMessage = ai_enabled && !user
    const defaultImageProfile = getUserImage(user?.gender)

    const remap = {
      id: +incomingMessage.id,
      chatId: +incomingMessage.chat_id,
      message: incomingMessage.message,
      messageType: incomingMessage.message_type || null,
      updatedAt: incomingMessage.updated_at,
      createdAt: incomingMessage.created_at,
      flag: dayjs(incomingMessage.created_at).format('DD MMMM YYYY'),

      user: {
        id: isAiMessage ? null : user?.id ?? null,
        name: isAiMessage
          ? 'AIsha'
          : user?.name || 'Deleted User',

        isAdmin: isAiMessage
          ? true
          : user?.is_admin ?? null,

        isMe: false,

        userProfile: isAiMessage
          ? AiShaImage
          : user?.photo_profile || defaultImageProfile,
      },
    }
    const finalData = [...dataMessageList, remap]

    setDataMessageList(finalData)

    const isRequestCs = ['/cs', 'chat /cs'].includes(incomingMessage.message)
    const isClosedChat = dataChatDetail?.status?.id === 88
    if (isRequestCs || isClosedChat) {
      reloadAll()
    }
  }

  // --- DELETE CHAT ---
  const onDoneDelete = () => {
    reloadList()
    clearSelectedChat()
  }

  const handleDeleteChat = (val) => {
    const label = `Chat ${val.chateble.label} - ${val.user.name}`
    modalDeleteData('Chat', val.id, label, deleteChat, onDoneDelete)
  }

  useEffect(() => {
    if(dataChat) {
      setDataChatDetail(dataChat)
      setDataMessageList(null)
      getDetailMessages(dataChat.id)
      getDetailChat(dataChat.id)
      setTextMessage('')
    }

    //eslint-disable-next-line 
  }, [dataChat])

  useEffect(() => {
    scrollToBottom()
  }, [dataMessageList]);

  useEffect(() => {
    handleIncomingMessage(incomingMessage)
    // eslint-disable-next-line
  }, [incomingMessage])

  // helpers
  const openNewTab = (url) => {
    window.open(url, '_blank').focus()
  }
  function getLastSegment(path) {
    return path.substring(path.lastIndexOf('/') + 1)
  }
  function getExtension(fileName) {
    const parts = fileName.split('.')
    return parts[parts.length - 1]
  }

  // VIEWS
  const cardMessage = (val) => {
    const renderInfo = (val) => {
      return <Group>
        {val.user.userProfile && <Avatar src={val.user.userProfile} alt="it's me" size="sm" />}
        <Badge color="gray" my={10} variant="white">
          {val.message}
        </Badge>
      </Group>
    }

    const renderMessage = (val) => {
      const _viewImage = () => {
        return (
          <Box style={{ cursor: 'pointer' }} pos={'relative'}>
            <LoadingOverlay
              w={190} h={210}
              visible={val.isLoading || val.isFail}
              zIndex={1000}
              overlayProps={{ radius: "sm", blur: 3 }}
              loaderProps={{
                children: val.isFail ? <IconExclamationCircle size={18} color="gray" />
                  : <Loader size={14} color="gray" />
              }}
            />
            <Image w={190} h={210} radius='md' src={val.message !== null ? val.message : NoImage} onClick={() => openNewTab(val.message)} />
          </Box>
        )
      }
      const _viewDocument = () => {
        return (
          <Box pos={'relative'}>
            <LoadingOverlay
              visible={val.isLoading || val.isFail}
              zIndex={1000}
              overlayProps={{ radius: "sm", blur: 3 }}
              loaderProps={{
                children: val.isFail ? <IconExclamationCircle size={18} color="gray" />
                  : <Loader size={14} color="gray" />
              }}
            />
            <Paper shadow="sm" withBorder p='sm' style={{ cursor: 'pointer'}} onClick={() => openNewTab(val.message)}>
              <Flex>
                <Text size="xs" lineClamp={1}>{getLastSegment(val.message)}</Text>
                <Text size="xs">.{getExtension(val.message)}</Text>
              </Flex>
            </Paper>
          </Box>
        )
      }
      const _viewTextArea = () => {
        return (
          <Textarea
            w={'100%'}
            variant="unstyled"
            value={val.message}
            autosize
            readOnly
          />
        )
      }

      return (
        <Card padding="md" radius="md" withBorder w={'360'} style={{ backgroundColor: val.user.isMe ? '#F5F5F7' : ''}} b>
          <Stack>
            <Flex gap='sm' align='center' direction={val.user.isAdmin ? 'row-reverse' : 'row'}>
              <Avatar src={val.user.userProfile} alt="it's me" size="sm" />
              <Box>
                <Text fz={12} fw='600' c={'red.5'} lineClamp={2}>
                  {val.user.name}
                  <span style={{ fontWeight: 'normal' }}>
                    { val.user.isAdmin
                      ? ' (Admin)'
                      : ` (Chat ${dataChatDetail.chateble.label})`
                    }
                  </span>
                </Text>
              </Box>
            </Flex>

            <Stack>
              {
                val.messageType === 'image' ? _viewImage()
                : val.messageType === 'document' ? _viewDocument()
                : _viewTextArea()
              }

              <Group justify="space-between">
                <Text fz={12} c={'gray.6'}>
                  {dayjs(val.createdAt).format('DD MMMM YYYY')} - { dayjs(val.createdAt).format('HH:mm:ss')}
                </Text>

                {
                  val.isLoading ? <Loader size={16} color="gray" />
                  : val.isFail ? <Tooltip position="top-end" label="Failed to send message. It will be cleared on page reload."><IconExclamationCircleFilled size={16} color="red" /></Tooltip>
                  : null
                }
              </Group>
            </Stack>
          </Stack>
        </Card>
      )
    }

    return val.messageType === 'info' ? renderInfo(val) : renderMessage(val)
  }

  const remapDetailMessages = (messageList) => messageList.map((val, index) => {
    return (
      <Flex key={index} direction={val.user.isAdmin ? 'row-reverse' : 'row'} justify={val.messageType === 'info' ? 'center' : ''}>
        {cardMessage(val)}
      </Flex>
    )
  })

  const topSection = (detailChat) => {
    return (
      <Stack mr={10} gap={'sm'}>
        <Group justify="space-between">
          <Text fw={500}>Chat History</Text>

          <Menu shadow="md" position="bottom-end"  width={200} withArrow>
            <Menu.Target>
              <ActionIcon variant="subtle" color="gray" aria-label="Settings">
                <IconDotsVertical style={{ width: '70%', height: '70%' }} stroke={1.5} />
              </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item
                disabled
                leftSection={<IconCopy size={14} />}
              >
                Copy Transcript
              </Menu.Item>
              <Menu.Item
                color="red"
                leftSection={<IconTrash size={14} />}
                onClick={() => handleDeleteChat(detailChat)}
              >
                Delete Chat
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>

        <Group>
          <Text
            size={'sm'}
          >
            Topic: <span
              style={{ color: 'blue', cursor: 'pointer' }}
              onClick={() => detailChat.chateble.id && openNewTab(`/${detailChat?.chateble?.key?.toLowerCase()}/${detailChat.chateble.id}`)}
            >
              {detailChat.chateble.label}
            </span>
          </Text>
          <Text size={'sm'}>
            Status: <span>
              <Badge
                size="sm"
                variant='light'
                color={detailChat.status.id === 86 ? 'red' // chat status is open
                  : detailChat.status.id === 87 ? 'green' // chat status is proggress
                    : detailChat.status.id === 92 ? 'orange' // chat status is ai active
                      : 'gray'
                }
              >
                {detailChat.status.name}
              </Badge>
            </span>
          </Text>
          <Text size={'sm'}>
            Assignee: <span
              style={{ cursor: 'pointer' }}
              onClick={() => openModalAssignees(detailChat)}
            >
              {
                detailChat?.assignees?.length === 1
                  ? detailChat?.assignees[0]?.user_name
                  : detailChat?.assignees?.length > 1
                    ? 'Multiple Admin'
                    : 'Unassigneed'
              }
            </span>
          </Text>
        </Group>
      </Stack>
    )
  }

  const bottomSection = (detailChat) => {
    if (detailChat?.status?.id === 86 /** status open */
      || detailChat?.status?.id === 87 /** status proggres */
      || detailChat?.status?.id === 92 /** status ai active */
    ) {
      if (detailChat?.participants?.includes(userAuth.id)) {
        return (
          <Group mt={20} align='center' grow preventGrowOverflow={false} wrap="nowrap" gap="xs">
             <Menu position="top-start" shadow="md" width={200}>
              <Menu.Target>
                <ActionIcon color="gray" variant="subtle" aria-label="Settings">
                  <IconPaperclip style={{ width: '70%', height: '70%' }} stroke={1.5} />
                </ActionIcon>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Item>
                  <Dropzone
                    openRef={openRefImage}
                    onDrop={(file) => handleSendImage(file)}
                    activateOnClick={false}
                    style={{ padding: '0', cursor: 'pointer'}}
                    onReject={(files) => handleErrorFile(files)}
                    maxSize={1000000}
                    accept={[
                      'image/jpeg',
                      'image/jpg',
                      'image/png',
                      'image/gif',
                      'image/tiff',
                      'image/webp',
                      'image/svg+xml',
                      'image/bmp',
                    ]}
                  >
                    <Group justify="center">
                      <Box onClick={() => openRefImage.current?.()} style={{ pointerEvents: 'all' }}>
                        Attach Image
                      </Box>
                    </Group>
                  </Dropzone>
                </Menu.Item>
                <Menu.Item>
                  <Dropzone
                    openRef={openRefDocument}
                    onDrop={(file) => handleSendDocument(file)}
                    activateOnClick={false}
                    style={{ padding: '0', cursor: 'pointer'}}
                    onReject={(files) => handleErrorFile(files)}
                    maxSize={1000000}
                    accept={[
                      'application/pdf',
                      'application/msword', // DOC
                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
                      'application/vnd.ms-excel', // XLS
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX
                      'application/vnd.ms-powerpoint', // PPT (assuming PPX meant PPT)
                      'application/vnd.openxmlformats-officedocument.presentationml.presentation', // PPTX
                      'application/rtf',
                      'text/plain', // TXT
                    ]}
                  >
                    <Group justify="center">
                      <Box onClick={() => openRefDocument.current?.()} style={{ pointerEvents: 'all' }}>
                        Attach Document
                      </Box>
                    </Group>
                  </Dropzone>
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>

            <ActionIcon color="gray" variant="subtle" aria-label="Settings" onClick={() => setShowPicker((val) => !val)}>
              <IconMoodSmile style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
            <Textarea
              value={textMessage}
              w={'92%'}
              autosize
              placeholder='Type a Message' 
              onChange={(val) => setTextMessage(val.target.value)}
              onKeyDown={handleKeyDown}
            />

            <ActionIcon variant="filled" aria-label="Settings" onClick={() => handleSendMessage()}>
              <IconSend2 style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Group>
        )
      }

      return (
        <Center mt={20}>
          <Button loading={loadingJoinChat} onClick={() => handleJointChat()}>Joint as {userAuth.name}</Button>
        </Center>
      )
    }
  }

  const renderDetail = (detailChat, messageList) => {
    return (
      <Card padding="md" radius="md" withBorder>
        <Grid>
          <Grid.Col span={8} style={{ borderRight: '1px solid #eeefef' }}>
            {topSection(detailChat)}

            <Divider my="sm" />

            {/** Chat */}
            <ScrollArea h={height / 1.65} scrollbarSize={6} scrollHideDelay={500}>
              <Stack
                align="stretch"
                gap="md"
                justify="flex-end"
              >
                {messageList && remapDetailMessages(messageList)}
                <Box ref={messagesEndRef} />
              </Stack>
            </ScrollArea>

            {loadingMessageList && <Center><Loader size={30} type="dots" /></Center>}

            {showPicker && (
              <div style={{ position: "absolute", bottom: "50px", left: 0, zIndex: 10 }} >
                <EmojiPicker width={320} height={400} onEmojiClick={handleEmojiClick} />
              </div>
            )}

            {bottomSection(detailChat)}
          </Grid.Col>

          <Grid.Col span={4}>
            <Text fw={500}>User Profile</Text>
            <Divider my="sm" />
            <Box ml={4} mb={8} >
              <Text fz={18} fw='600' lineClamp={2}>{detailChat.user.name}</Text>
              <Text fz={12}>{detailChat.user.email}</Text>
              <Text fz={12}>{detailChat.user.phone}</Text>
            </Box>

            <SimpleGrid cols={1} mt={10}>
              <Button size="xs" radius="md" variant="outline" onClick={() => openNewTab(`/users/${detailChat.user.id}`) }>User Profile</Button>
              {
                detailChat.status.id === 87
                && <Button size="xs" radius="md" loading={loadingCloseChat} onClick={() => onCloseChatConfirmation(detailChat.chateble.label)}>Close Chat</Button>
              }
              <Button size="xs" radius="md" onClick={() => getDetailMessages(dataChatDetail.id)}>Reload</Button>
            </SimpleGrid>
          </Grid.Col>
        </Grid>
      </Card>
    )
  }

  const renderAssignees = (userList) => userList.map((user, index) => {
    return (
      <Card shadow="sm" radius="md" my={10} withBorder style={{ cursor: 'pointer' }} onClick={() => openNewTab(`/users/${user.user_id}`)}>
        <Group key={index} flex="1" align='center'>
          <Flex gap='sm' align='center'>
            <Avatar variant='filled' name={user.user_name} radius="xl" size="sm" color='red' />
            <Box>
              <Text fz={12} fw='600' lineClamp={2}>{user.user_name}</Text>
            </Box>
          </Flex>
        </Group>
      </Card>
    )
  })

  return (
    <Box>
      {dataChatDetail && renderDetail(dataChatDetail, dataMessageList)}

      <Modal opened={modalAssignees} title="User Admin List" onClose={() => setModalAssignees(false)} >
        {renderAssignees(dataAssignees)}
      </Modal>
    </Box>
  )
}

export default DetailChat